import React from "react";
import { Navigate } from "react-router-dom";
import { useWorkspace } from "../../contexts/Workspacecontext";

// ─── WorkspaceGuard ───────────────────────────────────────────────────────────
// Wraps any protected page. If workspace hasn't been chosen yet, send user
// to /select-workspace first.
// ─────────────────────────────────────────────────────────────────────────────
const WorkspaceGuard = ({ children }) => {
  const { workspace } = useWorkspace();

  if (!workspace) {
    return <Navigate to="/select-workspace" replace />;
  }

  return children;
};

export default WorkspaceGuard;
